import { render, staticRenderFns } from "./Createpartner.vue?vue&type=template&id=72831eba&scoped=true"
import script from "./Createpartner.vue?vue&type=script&lang=js"
export * from "./Createpartner.vue?vue&type=script&lang=js"
import style0 from "./Createpartner.vue?vue&type=style&index=0&id=72831eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72831eba",
  null
  
)

export default component.exports